// src/components/learning/RouteProgressTracker.jsx

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import {
  derivePlayCtxFromPath,
  markPageCompleted,
} from "../../lib/learning/progress";
import { playUrl } from "../../flows/registry";

export default function RouteProgressTracker() {
  const location = useLocation();

  useEffect(() => {
    const ctx = derivePlayCtxFromPath(location.pathname);

    if (!ctx) {
      return;
    }

    /*
     * This only updates furthest-level progress.
     * It does NOT award XP.
     * XP is awarded only in LevelResult.jsx using levelScoring.js.
     */
    if (ctx.pageKey === "result") {
      void markPageCompleted({ ...ctx }, 100).catch((error) => {
        console.warn("Could not save completed level progress:", error);
      });
    }
  }, [location.pathname]);

  return null;
}

export function go(
  navigate,
  ctx,
  currentPageKey,
  nextSegment,
  pct = 100
) {
  /*
   * Save route progress in the background.
   * This does NOT award XP.
   */
  void markPageCompleted(
    {
      ...ctx,
      pageKey: currentPageKey,
    },
    pct
  ).catch((error) => {
    console.warn("Could not save page progress:", error);
  });

  navigate(playUrl(nextSegment));
}